import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  headerContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    borderBottom: `1px solid ${capitalDesignTokens.semanticColors.border.secondary}`,
    padding: '16px 24px',
    width: '100%',
    backgroundColor: capitalDesignTokens.semanticColors.background.primary
  },
  headerRow: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  headerActions: {
    display: 'flex',
    gap: '8px'
  },
  title: {
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold
  },
  titleContainer: {
    display: 'flex',
    flexDirection: 'column'
  },
  subtitle: {
    color: capitalDesignTokens.semanticColors.foreground.secondary,
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold,
    lineHeight: '20px'
  },
  subtitleLabel: {
    lineHeight: '20px'
  },
  subtitleContainer: {
    display: 'flex',
    gap: '4px'
  }
});
